/* eslint-disable prettier/prettier */
import { api } from './axios';

export const RoleService = {
  getRoles: async () => api.get('/roles'),
  getPermissions: async () => api.get('/permissions'),
  create: async (data: any) => api.post('/roles', data),
  update: async (id: string, data: any) => api.patch(`/roles/${id}`, data),
  delete: async (id: string) => api.delete(`/roles/${id}`),
  getById: async (id: string) => api.get(`/roles/${id}`),
};
